export const CURRENCY_TYPES: string[] = ['Euro', 'Dollar', 'Frank'];
